export default "__VITE_ASSET__0f79f4ec__"